/*eslint-disable */
import React from "react";
import { useState, useEffect } from "react";

import ReactHtmlParser from "react-html-parser";
import { useInterval, useBoolean } from "react-use";

import Corpo from "../components/Corpo";

import { globalPopup, closeGlobalPopup } from "../services/popup";
import { registerMatchAnswer } from "../services/match-answer-service";


/* eslint-disable */
export default function TabPergunta(props) {
  const [scoreLifeRepresentation, setScoreLifeRepresentation] = useState([]);
  const [scoreMultiplier, setScoreMultiplier] = useState([]);
  const [scoreMultiplierIndex, setScoreMultiplierIndex] = useState(0);
  const [scorePoints, setScorePoints] = useState(0);
  const [perguntaSelecionada, setPerguntaSelecionada] = useState({});
  const [respondeu, setRespondeu] = useState(false);
  const [errou, setErrou] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [currentWidth, setCurrentWidth] = useState(0);
  const [nivelDificuldade, setNivelDificuldade] = useState("");

  const [count, setCount] = React.useState(0);
  const [delay] = React.useState(1000);
  const [isRunning, toggleIsRunning] = useBoolean(true);

  const routeParam = props.location.pathname
    .replace("/tab/pergunta/", "")
    .split("/");

  let getIndexQuestion = () => {
    return routeParam[3];
  };

  let indexPergunta = routeParam[3];
  let nDif = routeParam[2];

  let updateTimer = () => {
    let tempo = tempo0 - count;
    console.log(tempo, "tempo");
    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));

    setCurrentTime(tempo);
    setCurrentWidth(100 - Math.round((tempo / getCurrentMaxTime()) * 100));

    if (tempo === 0) {
      console.log("update", window.GLOBALS.actualSingleMatch.lastAnswer);

      window.GLOBALS.actualSingleMatch.lastAnswer.indexPergunta = getIndexQuestion();
      window.GLOBALS.actualSingleMatch.lastAnswer.dificuldadeResposta = nDif;
      window.GLOBALS.actualSingleMatch.lastAnswer.resultdoResposta = "errou";
      
      setErrou(true);

      // let dadosResposta = {
      //   user_id: window.GLOBALS.user.info.user_id,
      //   match_id: window.GLOBALS.actualSingleMatch.match_id,
      //   question_id: perguntaSelecionada.question_id,
      //   answer_id: null,
      //   match_answer_result: 0,
      //   match_answer_time: 0,
      //   match_answer_difficulty: nivelDificuldade,
      // };

      // setResposta(dadosResposta).then(() => {
      //   console.log("Salvou");
      // });


      let matchAnswer = {
        idPartida: window.GLOBALS.actualSingleMatch.match_id,
        idPergunta: perguntaSelecionada.id,
        tempoResposta: 0,
        dificuldade: nivelDificuldade,
        qtdPontos: 0
      };

      registerMatchAnswer(matchAnswer).then((_) => {
        console.log("Salvou");
      });

      globalPopup(
        "Análise da resposta",
        true,
        [
          {
            texto: "OK",
            acao: () => {
              voltar();
              closeGlobalPopup();
            },
          },
        ],
        "Esgotou-se o tempo para responder a questão.<br /><br /><br /><br /><br /><br /><br /><br />"
      );

      setRespondeu(true);
      toggleIsRunning();
    }

    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
  };

  let trataResposta = (idResposta) => {
    // Caso já tenha respondido não executa a verificação
    if (respondeu) {
      return;
    }

    toggleIsRunning();

    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));

    let mensagem, points;

    window.GLOBALS.actualSingleMatch.lastAnswer =window.GLOBALS.actualSingleMatch.lastAnswer || {};
    window.GLOBALS.actualSingleMatch.lastAnswer.indexPergunta = indexPergunta;
    window.GLOBALS.actualSingleMatch.lastAnswer.dificuldadeResposta = nDif;

    // let dadosResposta = {
    //   user_id: window.GLOBALS.user.info.user_id,
    //   match_id: window.GLOBALS.actualSingleMatch.match_id,
    //   question_id: perguntaSelecionada.question_id,
    //   answer_id: perguntaSelecionada.listaRespostas[idResposta].answer_id,
    //   match_answer_time: getCurrentMaxTime() - currentTime,
    //   match_answer_difficulty: nivelDificuldade,
    // };

    // console.log('window.GLOBALS.actualSingleMatch', window.GLOBALS.actualSingleMatch);

    let matchAnswer = {
      idPartida: window.GLOBALS.actualSingleMatch.match_id,
      idResposta: perguntaSelecionada.listaRespostas[idResposta].id,
      tempoResposta: getCurrentMaxTime() - currentTime,
      dificuldade: nivelDificuldade,
      qtdPontos: 0
    };

    // Analisando a resposta
    if (perguntaSelecionada.listaRespostas[idResposta].respostaCorreta === 'S') {
      // Avisa ao state.change.controller que acertou
      window.GLOBALS.actualSingleMatch.lastAnswer.resultdoResposta = "acertou";

      // Ve se já acertou 10 perguntas, seta bonus
      let bonus = 0;
      window.GLOBALS.actualSingleMatch.numeroDeAcertos++;

      if (window.GLOBALS.actualSingleMatch.numeroDeAcertos === 10) {
        bonus = window.CONFIG.single.scorePer10Wins;
        mensagem =
          "Parabéns!<br /><br />Você acertou.<br /><br />" +
          "Você conseguiu a marca 10 perguntas corretas, parabéns!<br /><br />" +
          "Ganhou um bônus de " +
          bonus +
          " pontos.<br />";
        window.GLOBALS.actualSingleMatch.numeroDeAcerto = 0;
      } else {
        mensagem =
          "Parabéns!<br /><br />Você acertou.<br /><br /><br /><br /><br /><br />";
      }

      // Marca como acerto para o histórico
      //dadosResposta.match_answer_result = 1;

      // Calcula os pontos: primeiro os pontos por acerto
      points = window.CONFIG.single.scorePerCorrect;
      // Multiplica pelo multiplicador de acertos consecutivos
      points =
        points *
        window.CONFIG.single.scoreMultiplier[
          window.GLOBALS.actualSingleMatch.scoreMultiplierIndex
        ];
      // Multiplica pelo multiplicador de dificuldade
      points =
        points *
        window.CONFIG.single.scoreMultipliersPerTime["FMD".indexOf(nDif)];
      window.GLOBALS.actualSingleMatch.scorePoints += points + bonus;

      matchAnswer.qtdPontos = points + bonus

      setScorePoints(window.GLOBALS.actualSingleMatch.scorePoints);
      // ----- Grava usuário - Pontos totais + points da pergunta
      window.GLOBALS.user.info.match_points += points + bonus;
      // Update DB
      //setUser(window.GLOBALS.user.info);
      // Update Local Storage
      // updateUserLS({
      //   match_points: window.GLOBALS.user.info.match_points,
      // });
    } else {
      window.GLOBALS.actualSingleMatch.lastAnswer.resultdoResposta = "errou";
      setErrou(true);
      mensagem =
        "Que pena, desta vez você não acertou.<br /><br /><br /><br /><br /><br /><br />";
      // Marca como erro para o histórico
      //dadosResposta.match_answer_result = 0;
    }

    registerMatchAnswer(matchAnswer).then((_) => {
      globalPopup(
        "Análise da resposta",
        true,
        [
          {
            texto: "OK",
            acao: () => {
              closeGlobalPopup();
            },
          },
        ],
        mensagem
      );

      setRespondeu(true);
    });

    // setResposta(dadosResposta).then((data) => {
    //   globalPopup(
    //     "Análise da resposta",
    //     true,
    //     [
    //       {
    //         texto: "OK",
    //         acao: () => {
    //           closeGlobalPopup();
    //         },
    //       },
    //     ],
    //     mensagem
    //   );

    //   setRespondeu(true);
    // });

    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
  };

  let getCurrentMaxTime = () => {
    return window.CONFIG.single.secondsPerDificulties["FMD".indexOf(nDif)];
  };

  let tempo0 = getCurrentMaxTime();

  let tratarExibicaoResposta = (idResposta) => {
    if (respondeu) {
      if (perguntaSelecionada.listaRespostas[idResposta].respostaCorreta === 'S') {
        return 1;
      } else {
        return 0;
      }
    }
  };

  let classRespondeu = (res) => {
    switch (res) {
      case 0:
        return " resposta-errada";

      case 1:
        return " resposta-correta";

      default:
        return "";
    }
  };

  let voltar = () => {
    localStorage.setItem("ACTUAL_DIFFICULT", nDif);
    localStorage.setItem("NAO_PERTUBE_POPUP", "true");

    if (errou === true) {
      localStorage.setItem("PERDEU_SCORE", "true");
    } else {
      localStorage.setItem("CHAMA_MULTIPLIER", "true");
    }

    props.history.go(-1);
  };

  useInterval(
    () => {
      setCount(count + 1);
      updateTimer();
    },
    isRunning ? delay : null
  );

  useEffect(() => {
    const abortController = new AbortController();

    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
    let scorePush = [];

    for (let i = 0; i < window.GLOBALS.actualSingleMatch.totalScoreLife; i++) {
      scorePush.push({
        status: window.GLOBALS.actualSingleMatch.scoreLife - 1 >= i ? 1 : 0,
      });
    }

    setScoreLifeRepresentation(scorePush);
    setPerguntaSelecionada(
      window.GLOBALS.actualSingleMatch.questions[indexPergunta]
    );

    setScoreMultiplier(window.CONFIG.single.scoreMultiplier);
    setScoreMultiplierIndex(
      window.GLOBALS.actualSingleMatch.scoreMultiplierIndex
    );
    setScorePoints(window.GLOBALS.actualSingleMatch.scorePoints);
    setNivelDificuldade(nDif);

    return function cleanup() {
      toggleIsRunning();
      abortController.abort();
    };
  }, []);

  return (
    <Corpo {...props}>
      <div name="tab-inicio" className="view-container tab-pergunta">
        <div className="view-jogo pane pane-game">
          <div
            className="scroll-content ionic-scroll  has-tabs-top"
            style={{ top: "0px" }}
          >
            <div className="row score">
              <div className="col score-life">
                <h5>Chance</h5>
                <div className="score-life-panel">
                  {scoreLifeRepresentation.map((rep, index) => (
                    <div
                      className={
                        "score-life-" + index + (rep.status ? " filled" : "")
                      }
                      key={index}
                    >
                      <span>{index}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col score-multiplicador">
                <ul>
                  <li
                    className={
                      "score-multiplicador-1x" +
                      (scoreMultiplierIndex === 0 ? " active" : "")
                    }
                  >
                    <span>{scoreMultiplier[0]}x</span>
                  </li>
                  <li
                    className={
                      "score-multiplicador-2x" +
                      (scoreMultiplierIndex === 1 ? " active" : "")
                    }
                  >
                    <span>{scoreMultiplier[1]}x</span>
                  </li>
                  <li
                    className={
                      "score-multiplicador-3x" +
                      (scoreMultiplierIndex === 2 ? " active" : "")
                    }
                  >
                    <span>{scoreMultiplier[2]}x</span>
                  </li>
                </ul>
              </div>
              <div className="col score-points">{scorePoints} Pts</div>
            </div>

            <div className="countdow">
              <div className="time" style={{ width: currentWidth + "%" }}></div>
            </div>

            <div className="pergunta-panel">
              <h2 className="pergunta-title">
                Pergunta #{perguntaSelecionada.id}
              </h2>
              <div className="pergunta-text">
                {ReactHtmlParser(perguntaSelecionada.descricao)}
              </div>
            </div>
            <div className="resposta-panel">
              <button
                type="button"
                className={
                  "button button-full button-resposta" +
                  classRespondeu(tratarExibicaoResposta(0))
                }
                onClick={() => trataResposta(0)}
              >
                <span>
                  {perguntaSelecionada.listaRespostas !== undefined &&
                    ReactHtmlParser(
                      perguntaSelecionada.listaRespostas[0].descricao
                    )}
                </span>
              </button>

              <button
                type="button"
                onClick={() => trataResposta(1)}
                className={
                  "button button-full button-resposta" +
                  classRespondeu(tratarExibicaoResposta(1))
                }
              >
                <span>
                  {perguntaSelecionada.listaRespostas !== undefined &&
                    ReactHtmlParser(
                      perguntaSelecionada.listaRespostas[1].descricao
                    )}
                </span>
              </button>

              <button
                type="button"
                onClick={() => trataResposta(2)}
                className={
                  "button button-full button-resposta" +
                  classRespondeu(tratarExibicaoResposta(2))
                }
              >
                <span>
                  {perguntaSelecionada.listaRespostas !== undefined &&
                    ReactHtmlParser(
                      perguntaSelecionada.listaRespostas[2].descricao
                    )}
                </span>
              </button>

              <button
                type="button"
                onClick={() => trataResposta(3)}
                className={
                  "button button-full button-resposta" +
                  classRespondeu(tratarExibicaoResposta(3))
                }
              >
                <span>
                  {perguntaSelecionada.listaRespostas !== undefined &&
                    ReactHtmlParser(
                      perguntaSelecionada.listaRespostas[3].descricao
                    )}
                </span>
              </button>

              <button
                type="button"
                className={
                  "button button-full button-lg" +
                  (respondeu ? "" : " out-off-layout")
                }
                onClick={() => voltar()}
              >
                Próxima
              </button>
            </div>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
